import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'components';

import { InterceptorsProvider } from 'src/app/_services/interceptors/intercepors.provider';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomPasswordFieldComponent } from './components/custom-password-field/custom-password-field.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { SettingsConComponent } from './components/settings-con/settings-con.component';
import { UserHeaderComponent } from './components/user-header/user-header.component';
import { TeamPageComponent } from '@brand-lolly/app/user-management/team/team-page/team-page.component';
import { UserSprintRoutingModule } from './user-sprint-routing.module';

@NgModule({
	imports: [
		ReactiveFormsModule,
		SharedModule,
		RouterModule,
		UserSprintRoutingModule,
		TranslateModule,
		FormsModule,
		MatButtonModule,
		MatDialogModule,
		IconComponent,
		UserHeaderComponent,
		MyProfileComponent,
		SettingsConComponent,
		TeamPageComponent,
		CustomPasswordFieldComponent
	],
	exports: [UserHeaderComponent],
	providers: [InterceptorsProvider]
})
export class UserSprintModule {}
